
export default props=>{
    const jsx = (<div className="">
        <style jsx>{`

.item{
    height: 100px;
    font-size: 14px;
    color: #343a40;

    padding: 8px 10px;
}

.item.highlight{
    background-color: #55d5ce;
    opacity: 0.1;
}

.dib{
    margin: 0 10px;
}

div.line{
    height: initial;
    line-height: initial;
}

.line{
    text-align: left;
    color: #343a40;
}

.l1{
    text-align: left;
    font-weight: bold;
}

.l2{
    font-size: 16px;
}

.left img{
    height: 100px;
    line-height: 100px;
    text
}

.left img{
    height: 80px;
}

.center{
    vertical-align: top;
    padding-top: 16px;
}

.right{
    float:right;
    padding-top: 20px;
    display: none;
}

.right img{
        height: 30px;
}

.highlighted .line{
    color:#55d5ce;
}

.highlighted .right{
    display: block;
}


`}</style>

<a href={props.url} target='_blank'>
        <div className={"item " + props.isHighlighted}>
            <div className="dib left">
                <img src={"/assets/imagesz/" + props.imgSrc} />
            </div>
            <div className="dib center ">
                <div className="line l1">{props.className}</div>
                <div className="line l2">{props.brandName}</div>
            </div>
            <div className="dib right ">
                <img src="/assets/images2/back2.svg" />
            </div>

        </div>
</a>

    </div>);

    return (jsx);
};
